/* eslint-disable react/require-default-props */
import React from 'react';
import {FlatList} from 'react-native';
import {get, isEmpty} from 'lodash';
import {noop} from 'lodash';

import LoadingIndicator from '/component/base/LoadingIndicator/LoadingIndicator';
import {TaskItemDescriptionComponent} from '/component/screen/ClientProfile/ClientJourney/TaskItem/TaskItemDescriptionComponent';
import {DownlineProfile} from '/constant/TestIDs';
import {WEEKLY_CHECK_IN} from '/enum/clientJourneyTasks.enum';
import {useTranslation} from '/provider/TranslationProvider';

import {getFormattedWeeklyCheckInsDate} from '../ClientJourneyTask.util';
import {TaskItem} from '../TaskItem';

import {useWeeklyCheckIns} from './WeeklyCheckIns.hook';
import {styles} from './WeeklyCheckIns.style';
interface WeeklyCheckInsProps {
  weeklyCheckInsInitialTasks?: any[];
  weeklyCheckInsTasks?: any[];
  fetchClientJourneyTask?: () => void;
  setClientJourneyTasks?: () => void;
  clientId?: number;
  onShowTaskDetail?: () => void;
  clientJourneyTimer?: number;
  hasWeeklyCheckInsTasks?: boolean;
  setClientJourneyState?: () => void;
  currentCheckInDate?: Date | string;
  lastCheckInDate?: string;
}

/**
 * @param {object} params - Parameters
 * @param {Object[]} params.filteredTasks - an object that contains tile data (description)
 * @param {string}   params.filteredTasks.tabDescription
 * @param {string}   params.filteredTasks.screenTabCode
 * @param {Object[]} params.filteredTasks.checkBox
 * @param {string}   params.filteredTasks.checkBox.screenTabCode
 * @param {string}   params.filteredTasks.checkBox.chkBoxCode
 * @param {string}   params.filteredTasks.checkBox.description
 * @param {Object[]} params.WeeklyCheckInsTasks - an object that contains data about the status of the checkbox
 * @param {number}   params.WeeklyCheckInsTasks.clientId
 * @param {string}   params.WeeklyCheckInsTasks.screenTabCode
 * @param {Object[]} params.WeeklyCheckInsTasks.checkIns
 * @param {string}   params.WeeklyCheckInsTasks.checkIns.chkBoxCode
 * @param {boolean}  params.WeeklyCheckInsTasks.checkIns.checkStatus
 * @param {function} params.fetchClientJourneyTask - function for sending a post request to change the status of the checkbox
 * @param {function} params.setClientJourneyTasks - function for changing the status in the redux
 */

export const WeeklyCheckIns: React.FC<WeeklyCheckInsProps> = ({
  weeklyCheckInsInitialTasks = [],
  weeklyCheckInsTasks = [],
  fetchClientJourneyTask = noop,
  setClientJourneyTasks = noop,
  clientId = null,
  onShowTaskDetail = noop,
  clientJourneyTimer = 6000,
  hasWeeklyCheckInsTasks = false,
  setClientJourneyState = noop,
  currentCheckInDate = null,
  lastCheckInDate = null,
}) => {
  const {ts} = useTranslation(
    'screen.clients.section.clientJourney.weeklyCheckIns',
  );
  const {tasks, onTaskStatusChange, getTaskItemIcon} = useWeeklyCheckIns({
    weeklyCheckInsInitialTasks,
    weeklyCheckInsTasks,
    fetchClientJourneyTask,
    setClientJourneyTasks,
    clientId,
    onShowTaskDetail,
    clientJourneyTimer,
    setClientJourneyState,
    lastCheckInDate,
    currentCheckInDate,
  });
  const renderWeeklyCheckInsDescComponent = (
    taskName: any,
    taskStatus: any,
  ) => {
    const itemStyle = {
      ...styles.weeklyCheckInsText,
      ...styles.selectedText,
    };

    if (
      taskName === WEEKLY_CHECK_IN &&
      weeklyCheckInsTasks.length > 0 &&
      (currentCheckInDate || lastCheckInDate)
    ) {
      const weeklyCheckInsDate = taskStatus
        ? getFormattedWeeklyCheckInsDate(currentCheckInDate)
        : getFormattedWeeklyCheckInsDate(lastCheckInDate);

      return (
        <TaskItemDescriptionComponent
          description={ts(
            'weeklyCheckInsText',
            `Last check-in ${weeklyCheckInsDate} · Repeats every week`,
          )}
          style={itemStyle}
          testID={DownlineProfile.cjWeeklyCheckinsDescription}
        />
      );
    } else {
      return (
        <TaskItemDescriptionComponent
          description={ts('weeklyCheckInsText', 'Repeats every week')}
          style={itemStyle}
          testID={DownlineProfile.cjWeeklyCheckinsDescription}
        />
      );
    }
  };
  const renderItem = (item: any) => {
    const label = get(item, 'item.label', 'Weekly check-in');
    const checkStatus = get(item, 'item.checkStatus');

    return (
      <TaskItem
        taskItem={item}
        onTaskStatusChange={onTaskStatusChange}
        iconName={getTaskItemIcon(checkStatus)}
        isChecked={checkStatus}
        onShowTaskDetail={onShowTaskDetail}
        weeklyCheckInsDescComponent={renderWeeklyCheckInsDescComponent(
          label,
          checkStatus,
        )}
      />
    );
  };

  // Preparing data for display
  if (isEmpty(tasks) && !hasWeeklyCheckInsTasks) {
    return <LoadingIndicator style={styles.loader} />;
  }

  return (
    <FlatList
      scrollEnabled={false}
      contentContainerStyle={styles.taskListContainer}
      data={tasks}
      // @ts-expect-error TS(2339): Property 'id' does not exist on type 'never'.
      keyExtractor={item => item.id}
      renderItem={renderItem}
    />
  );
};
